<template>
  <BaseModal id="unificado-search" :value="valueInternal" @input="change">
    <div class="flex-col flex justify-center pt-10">
      <input
        type="text"
        class="regular bordered clear m-2"
        placeholder="search - nkrCode - unificado - any"
        v-model="nkrCode"
        @input="getUnificado"
      />
      <div
        v-for="option in options"
        :key="option.nkrCode"
        class="flex flex-row py-4 items-center"
      >
        <span class="mx-4">
          {{ option.unificado }}
          <br />
          {{ option.customTitle }}
        </span>
        <button
          class="btn-success-button mr-4"
          @click="$emit('selected', option.unificado)"
        >
          select
        </button>
      </div>
    </div>
  </BaseModal>
</template>
<script>
import { debounce } from "lodash";
import { getProducts } from "@/api/store/ProductsService.js";

export default {
  name: "UnificadoFinder",
  props: ["value"],
  data() {
    return {
      valueInternal: false,
      nkrCode: "",
      options: []
    };
  },
  watch: {
    value() {
      this.valueInternal = this.value;
    }
  },
  methods: {
    change(val) {
      console.log(val);
      this.$emit("input", val);
    },
    getUnificado() {
      const code = this.nkrCode.replaceAll(" ", "");
      const search = debounce(async code => {
        if (code.length > 3) {
          const filters = {
            storeEnabled: "enabled",
            page: 1,
            limitPerPage: "3",
            orderCol: "nkr_code",
            orderDir: "asc",
            search: code,
            requestPrice: true,
            priceLevel: "online"
          };
          getProducts(filters).then(res => {
            this.options = res.products;
          });
        }
      }, 600);
      search(code);
    }
  }
};
</script>
<style lang="scss">
#unificado-search {
  .modal-content {
    max-width: 350px;
    height: auto;
  }
}
</style>
